import { isAppleSafari } from './is-apple-safari';

export const getDeeplink = () => {
  const deepLink = window.envUrls.INSURANCE_MOBILE_APP_HOT_LINK;

  isAppleSafari()
    ? (window.parent.location.href = deepLink)
    : window.open(deepLink, '_blank');
};
